import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
} from 'components-lib';

const UploadedFileModal = ({ onClose, user_id, file_id, file }) => {

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {

    }
  };

  document.addEventListener('keydown', handleKeyDown);
  return (
    <Modal isOpen={true} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          File Viewer
        </ModalHeader>
        <Text color="gray.700" ml="24px" className="font-bold" > To open Magnifier Press  Windows key + Plus and to close Windows key + Escape </Text>
        <ModalCloseButton  color="red" onClick={onClose} />
        <ModalBody>
          {file && (
            <>
              {/* <Text mb={4}>File: {file.imageUrl}</Text> */}
              {file.imageUrl?.endsWith('.pdf') ? (
                <iframe
                  src={file.imageUrl}
                  width="100%"
                  height="900px"
                  title="PDF Viewer"
                />
              ) : (
                <img
                  src={file.imageUrl}
                  alt="Uploaded file"
                  style={{ maxWidth: '100%' }}
                />
              )}
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
/**
 * UploadedFileModal - File Viewer and Management Modal
 * 
 * Modal component for viewing and managing uploaded files including
 * lab reports and medical documents. Supports multiple file formats
 * with preview capabilities and download functionality.
 * 
 * @component
 * @since 1.0.0
 * @author Kifayti Health 
 */
export default UploadedFileModal;
